import { Injectable, Injector } from "@angular/core";
import { environment } from "src/environments/environment";
import { Estimativa } from "../models/estimativa.model";
import { BaseService } from "../shared/services/base.service";
import { Observable } from "rxjs";
import { ParceiroEstimativa } from "../models/estimativa-parceiro.model";

@Injectable({
  providedIn: "root",
})
export class EstimativaParceiroService extends BaseService<Estimativa> {
  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/estimativa`, injector);
  }

  getAllEstimativaParceiros(): Observable<ParceiroEstimativa[]> {
    return this.http.get<ParceiroEstimativa[]>(
      `${environment.API_PRICE}/EstimativaParceiro`
    );
  }

  getOneEstimativaParceiros(id): Observable<ParceiroEstimativa[]> {
    return this.http.get<ParceiroEstimativa[]>(
      `${environment.API_PRICE}/EstimativaParceiro/${id}`
    );
  }

  deleteEstimativaParceiro(id): Observable<ParceiroEstimativa[]> {
    return this.http.delete<ParceiroEstimativa[]>(
      `${environment.API_PRICE}/EstimativaParceiro/${id}`
    );
  }

  atualizaEstimativaParceiro(
    estimativaParceiro
  ): Observable<ParceiroEstimativa[]> {
    return this.http.put<ParceiroEstimativa[]>(
      `${environment.API_PRICE}/EstimativaParceiro/${estimativaParceiro.id}`,
      estimativaParceiro
    );
  }

  criaEstimativaParceiro(
    estimativaParceiroNova
  ): Observable<ParceiroEstimativa[]> {
    return this.http.post<ParceiroEstimativa[]>(
      `${environment.API_PRICE}/EstimativaParceiro`,
      estimativaParceiroNova
    );
  }

  calculoValorVenda(idEstimativaParceiro): Observable<any> {
    return this.http.get(
      `${environment.API_PRICE}/EstimativaParceiro/totalVenda/${idEstimativaParceiro}`
    );
  }
}
